/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const SEARCH_CMS_DRUG_TAB_DATA = 'SEARCH_CMS_DRUG_TAB_DATA';
export const CMS_DRUG_DETAIL_TAB_DATA = 'CMS_DRUG_DETAIL_TAB_DATA';

export const GET_AUDIT_TYPE_DFD = 'GET_AUDIT_TYPE_DFD';
export const GET_MANUFACTURER_DATA_DFD = 'GET_MANUFACTURER_DATA_DFD';
export const HANDLE_ERROR_MESSAGE_FOR_DFD = 'HANDLE_ERROR_MESSAGE_FOR_DFD';
export const GET_CMS_DRUG_BY_CRITERIA = 'GET_CMS_DRUG_BY_CRITERIA';

export const GET_SEARCH_CMS_DRUG_BY_CRITERIA_LIST =
  'GET_SEARCH_CMS_DRUG_BY_CRITERIA_LIST';

export const UPDATE_AUDIT_CLEARED_INDEX_DATA_DFD =
  'UPDATE_AUDIT_CLEARED_INDEX_DATA_DFD';

export const PREVIOUS_DRUG_DATA_DFD = 'PREVIOUS_DRUG_DATA_DFD';
export const DETAIL_SCREEN_OBJ_DFD = 'DETAIL_SCREEN_OBJ_DFD';
export const MFG_SELECTED = 'MFG_SELECTED';
export const RESET_REDUX_DFD = 'RESET_REDUX_DFD'
export const SUCCESSFUL_DATA_PAYLOAD = 'SUCCESSFUL_DATA_PAYLOAD'
